import { createSelector } from 'reselect';

const getState = (state) => state.personalConfiguration || {};

export const selectPersonalConfiguration = createSelector(
  getState,
  (data) => data
);

export const selectShowMenuSearch = createSelector(
  getState,
  ({ showMenuSearch }) => showMenuSearch
);

export const selectShowGlobalPeriod = createSelector(
  getState,
  ({ showGlobalPeriod }) => showGlobalPeriod
);

export const selectGlobalPeriod = createSelector(
  getState,
  ({ globalPeriod }) => globalPeriod
);